import { uniq } from 'underscore';

import { Session } from '@/types/session.types';

const getAllProjectLanguages = (sessions?: Session[]): string[] => {
  return uniq((sessions || []).reduce((acc: string[], cur) => [...acc, ...cur.languages], []) || []);
};

export default getAllProjectLanguages;
